// import { useSearchParams } from "react-router";

import { TagContextOptions, useTagFiltersData } from "src/components/Filter/TagFilter/useTagFiltersData";

// import { TagFilterConfig } from "src/components/Filter/TagFilter";

// const urlToApiFilters = (filterString: URLSearchParams, defaultValues: UrlFilterParams): AxiosParams => {
//     const acc: AxiosParams = {};

//     const columnFilters = Object.entries(defaultValues).reduce((acc, [field, item]) => {
//         const { value } = item;
//         if (Array.isArray(value)) {
//             const valueFromUrl = filterString.getAll(field);
//             if (valueFromUrl.length === 0) return acc;

//             acc[field] = valueFromUrl;
//             return acc;
//         }
//         if (typeof value === "string") {
//             const valuesFromUrl = filterString.get(field);
//             if (valuesFromUrl === null) return acc;

//             acc[field] = valuesFromUrl;
//             return acc;
//         }

//         return acc;
//     }, acc);

//     return columnFilters;
// };

type UrlFilterParams = Record<
    string,
    {
        value: string | string[];
    }
>;

export type ApiFiltersUrlSyncOptions = {
    // defaultValues: UrlFilterParams;
    searchParams: URLSearchParams;
    tagContext?: TagContextOptions;
};
export const useApiFiltersUrlSync = (options?: ApiFiltersUrlSyncOptions) => {
    const { searchParams = new URLSearchParams(), tagContext } = options || {};

    const { tagValues } = useTagFiltersData({ context: tagContext });
    const tagValueToSlug = tagValues.reduce(
        (acc, v) => {
            acc[v.name] = v.slug;
            return acc;
        },
        {} as Record<string, string>,
    );

    const reservedKeys = ["sort", "page", "itemsPerPage"];
    const _filterKeys = [...searchParams.keys()].reduce((acc, urlKey) => {
        if (reservedKeys.includes(urlKey)) {
            return acc;
        }
        acc.add(urlKey);
        return acc;
    }, new Set<string>());
    const filterKeys = Array.from(_filterKeys);

    return {
        filters: urlToFilters(searchParams, filterKeys, tagValueToSlug),
    };
};

const urlToFilters = (
    url: URLSearchParams,
    keys: string[],
    tagValueToSlug?: Partial<Record<string, string>>,
): AxiosParams => {
    const acc: AxiosParams = {};

    const tagsAcc: { type: string; value: string[] }[] = [];
    const emptyTypeAcc: string[] = [];
    const notEmptyTypeAcc: string[] = [];

    const axiosParams = keys.reduce((acc, urlKey) => {
        // Handle tag empty/notEmpty operators: tag_phase-projet[empty]=true or tag_phase-projet[notEmpty]=true
        const tagEmptyMatch = urlKey.match(/^tag_(.+)\[(empty|notEmpty)\]$/);
        if (tagEmptyMatch) {
            const tagTypeSlug = tagEmptyMatch[1];
            const operator = tagEmptyMatch[2];
            const value = url.get(urlKey);
            if (value === "true") {
                if (operator === "empty") {
                    emptyTypeAcc.push(tagTypeSlug);
                } else {
                    notEmptyTypeAcc.push(tagTypeSlug);
                }
            }
            return acc;
        }

        if (urlKey.startsWith("tag_")) {
            const tagTypeSlug = urlKey.replace("tag_", "");
            const _values = url.get(urlKey);
            if (_values === null) {
                return acc;
            }
            const values = _values.split(",").map((i) => {
                const slug = tagValueToSlug?.[i];
                if (slug === undefined) {
                    // Just a security but it's not supposed to work if it does that
                    return i;
                }
                return slug;
            });

            tagsAcc.push({
                type: tagTypeSlug,
                value: values,
            });
            return acc;
        }

        if (urlKey.endsWith("[]")) {
            const valuesFromUrl = url.getAll(urlKey);
            if (valuesFromUrl.length === 0) return acc;

            const formattedKey = urlKey.slice(0, urlKey.length - 2);
            acc[formattedKey] = valuesFromUrl;
            return acc;
        }

        const valueFromUrl = url.get(urlKey);
        if (valueFromUrl === null) {
            return acc;
        }
        acc[urlKey] = valueFromUrl;
        return acc;
    }, acc);

    if (tagsAcc.length > 0) {
        axiosParams["tags[type_and_value]"] = JSON.stringify(tagsAcc);
    }

    if (emptyTypeAcc.length > 0) {
        axiosParams["tags[empty_type]"] = emptyTypeAcc.join(",");
    }

    if (notEmptyTypeAcc.length > 0) {
        axiosParams["tags[not_empty_type]"] = notEmptyTypeAcc.join(",");
    }

    return axiosParams;
};

// tag_tag1=coutag1,coutag1..2
// tag_tag3=single-3

// const transformTagFiltersToApiParams = (tagFilters: Record<string, TagFilterConfig>): AxiosParams => {
//     const tagParams: AxiosParams = {};

//     Object.entries(tagFilters).forEach(([tagTypeSlug, config]) => {
//         switch (config.mode) {
//             case "has_type":
//                 // Backend expects: tags[has_type]=Client
//                 tagParams[`tags[has_type]`] = tagTypeSlug;
//                 break;
//             case "has_value":
//                 if (config.value) {
//                     // Backend expects: tags[has_value]=Carrefour
//                     tagParams[`tags[has_value]`] = config.value;
//                 }
//                 break;
//             case "exact_values":
//                 if (config.values && config.values.length > 0) {
//                     // Use has_value for each value - backend will OR them
//                     config.values.forEach((value) => {
//                         if (!tagParams[`tags[has_value]`]) {
//                             tagParams[`tags[has_value]`] = value;
//                         } else {
//                             // For multiple values, use type_and_value instead
//                             tagParams[`tags[type_and_value]`] = JSON.stringify({
//                                 type: tagTypeSlug,
//                                 value: value,
//                             });
//                         }
//                     });
//                 }
//                 break;
//             case "type_and_value":
//                 if (config.value) {
//                     // Backend expects: tags[type_and_value] with JSON
//                     tagParams[`tags[type_and_value]`] = JSON.stringify({
//                         type: tagTypeSlug,
//                         value: config.value,
//                     });
//                 }
//                 break;
//             case "predefined":
//                 tagParams[`tags[predefined]`] = true;
//                 break;
//         }
//     });

//     return tagParams;
// };

// const tagApiParams = transformTagFiltersToApiParams(tagFilters);
// // Convert MRT column filters to tag filters for API
// const convertColumnFiltersToTagFilters = (
//     columnFilters: MRT_ColumnFiltersState,
// ): Record<string, TagFilterConfig> => {
//     const tagFilters: Record<string, TagFilterConfig> = {};

//     columnFilters.forEach((filter) => {
//         // Check if this is a tag column filter (starts with "tag_")
//         if (filter.id.startsWith("tag_")) {
//             const tagTypeSlug = filter.id.replace("tag_", "");
//             const values = Array.isArray(filter.value) ? filter.value : [filter.value].filter(Boolean);

//             if (values.length > 0) {
//                 tagFilters[tagTypeSlug] = {
//                     mode: "exact_values",
//                     values: values,
//                 };
//             }
//         }
//     });

//     return tagFilters;
// };

// // // Extract tag filters from MRT column filters
// const tagFiltersFromMRT = convertColumnFiltersToTagFilters(gridFilters.columnFilters);
